/** Default app install deep link when masthead banner omits one. */
export const DEFAULT_APP_REDIRECT_DEEP_LINK = "https://fnp.onelink.me/xS2p/fjxq489m";

/**
 * Maps a masthead store's `redirectionAppBannerImg` into homepage banner props.
 * @param {object|null|undefined} store - Masthead store object from homepage feed
 * @returns {object|null} Banner props or null when the store has no image banner
 */
export function getStoreAppRedirectBannerData(store) {
  const banner = store?.redirectionAppBannerImg;
  if (!banner || banner.mediaType !== "image" || !banner.mediaValue) {
    return null;
  }

  return {
    imageUrl: banner.mediaValue,
    appDeepLink: DEFAULT_APP_REDIRECT_DEEP_LINK,
  };
}
